<template>
  <b-container fluid>
    <b-row>
      <b-col>
        <b-button
          :disabled="disabled"
          variant="primary"
          size="sm"
          squared
          class="px-5"
          @click="addDetailModalHandler"
        >
          เพิ่ม
        </b-button>
        <sweet-modal ref="detailAddModal">
          <sweet-modal-tab
            id="test-tab"
            title="Test"
          >
            <b-form-input
              v-model="testFilter"
              @input="updateTestItems"
            />
            <b-table
              ref="testTable"
              style="height: 500px; overflow-y: auto; text-align: left;"
              sticky-header
              responsive
              show-empty
              select-mode="single"
              selectable
              thead-class="hidden_header"
              :fields="fields"
              :items="testSuggestList"
              empty-text="ไม่มีผลลัพธ์"
              @row-selected="onRowSelectedTest"
            />
          </sweet-modal-tab>
          <sweet-modal-tab
            id="set-test-tab"
            title="Set Test"
          >
            <b-form-input
              v-model="setTestFilter"
              @input="updateSetTestItems"
            />
            <b-table
              ref="setTestTable"
              style="height: 500px; overflow-y: auto; text-align: left;"
              sticky-header
              responsive
              show-empty
              thead-class="hidden_header"
              select-mode="single"
              selectable
              :fields="fields"
              :items="setTestSuggestList"
              @row-selected="onRowSelectedSetTest"
            />
          </sweet-modal-tab>
        </sweet-modal>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
  import {mapActions} from 'vuex';
  import LabInvoiceDetailAddSuggestList from './LabInvoiceDetailAddSuggestList'

  export default {
    name: "LabInvoiceAddDetailModal",
    props: {
      items: {
        type: Array,
        default: () => [false],
      },
      ln: {
        type: String,
        default: '',
      },
      specieId: {
        type: Number,
        default: null
      },
      disabled: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        tests: [],
        testSuggestList: [],
        setTestSuggestList: [],
        setTests: [],
        testFilter: null,
        setTestFilter: null,
        fields: [
          { key: 'name', label: 'ชื่อ', thStyle: { display: 'none'}}
        ],
        suggestListComponent: LabInvoiceDetailAddSuggestList,
      }
    },
    computed: {
      itemsInput: {
        get() {
          return this.items
        },
        set(value) {
          this.$emit('update:items', value)
        }
      },
      testIdInput() {
        return this.items.map(item => item.test_id)
      },
      setTestIdInput() {
        return this.items.map(item => item.set_test_id)
      },
    },
    methods: {
      ...mapActions({
        'getTests': 'Test/getTestsBySpecie',
        'getSetTests': 'Test/getSetTestsBySpecie'
      }),
      async addDetailModalHandler() {
        this.tests = await this.getTests(this.specieId)
        this.testSuggestList = this.$rfdc(this.tests).filter(testSuggest => !this.testIdInput.includes(testSuggest.id)) // clone test
        this.setTests = await this.getSetTests(this.specieId)
        this.setTestSuggestList = this.$rfdc(this.setTests).filter(setTest => !this.setTestIdInput.includes(setTest.id)) // clone set test
        this.$refs['detailAddModal'].open()
      },
      async onRowSelectedTest(item) {
        if (item.length <= 0) {
          return
        }
        this.$refs['detailAddModal'].close();
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเพิ่ม',
          text: `คุณต้องการเพิ่ม ${item[0].name} เข้ารายการใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'เพิ่ม',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.itemsInput.push({
            name: item[0].name,
            test_id: item[0].id,
            price: item[0].price,
            ln: this.ln,
          })
          this.$swal.fire('สำเร็จ', 'เพิ่มรายการเรียบร้อย', 'success')
        } else {
          this.$refs['testTable'].clearSelected()
          this.$refs['setTestTable'].clearSelected()
          this.$refs['detailAddModal'].open()
        }
      },
      async onRowSelectedSetTest(item) {
        if (item.length <= 0) {
          return
        }
        this.$refs['detailAddModal'].close()
        const confirm = await this.$swal.fire({
          title: 'ยืนยันการเพิ่ม',
          text: `คุณต้องการเพิ่ม ${item[0].name} เข้ารายการใช่หรือไม่?`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'เพิ่ม',
          cancelButtonText: 'ยกเลิก',
          showLoaderOnConfirm: true,
        })

        if (confirm.value) {
          this.itemsInput.push({
            name: item[0].name,
            set_test_id: item[0].id,
            price: item[0].price,
            ln: this.ln,
          })
          this.$swal.fire('สำเร็จ', 'เพิ่มรายการเรียบร้อย', 'success')
        } else {
          this.$refs['testTable'].clearSelected()
          this.$refs['setTestTable'].clearSelected()
          this.$refs['detailAddModal'].open()
        }
      },
      updateTestItems(text) {
          this.testSuggestList = this.tests
            .filter(test => !this.testIdInput.includes(test.id))
            .filter(testSuggestion => String(testSuggestion.name.toLowerCase()).includes(text.toLowerCase()))
      },
      updateSetTestItems(text) {
        this.setTestSuggestList = this.setTests
          .filter(setTest => !this.setTestIdInput.includes(setTest.id))
          .filter(testSuggestion => String(testSuggestion.name.toLowerCase()).includes(text.toLowerCase()))
      }
    },

  }
</script>

<style lang="scss" scoped>

</style>
